import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// S-034: self-hosted fonts for South African languages, bundled as assets of this app (NFR-07).
import "@buza/fonts/fonts.css";
import { App } from "./App.js";
import "./parlour.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
